/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Link,useHistory } from 'react-router-dom'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {decryptData} from '../../../../app/modules/auth/components/util';

const HeaderUserMenu: FC = () => {
  const salt = process.env.SALT || '6d090796-ecdf-11ea-adc1-0242ac112345';

  const username = localStorage.getItem('username');
  const email = localStorage.getItem('ccEmail');
  var decryptedusername='',decryptedemail='';
  if(username){
    decryptedusername = decryptData(username, salt);
    decryptedemail = decryptData(email, salt);
  }

  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const history = useHistory();

  const handlePreferencesClick = () => {
    // Navigate to '/preference' route
    (history as any).push('/preference');

    // Reload the page after navigating
    window.location.reload();
  };
  return (
    
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={user.pic} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {decryptedusername}
             
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {decryptedemail}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>
     
    
<div className='menu-item px-8'>
  <Link to='/preference' className='menu-link px-5' style={{ display: 'inline-block' }} onClick={handlePreferencesClick} >
    Preferences
  </Link>
</div>
      


      <div className='separator my-2'></div>

    
<div className='menu-item px-8'>
  <img alt='Logo' src={toAbsoluteUrl('/media/logos/logout-Icon.svg')} className='h-20px radius-10' style={{ display: 'inline-block', marginRight: '3px' }} />
  <Link to='/logout' className='menu-link px-5' style={{ display: 'inline-block' }}>
    Sign out
  </Link>
</div>
</div>

  )
}

export {HeaderUserMenu}
